import {
  type IconDefinition,
  type IconName,
  type IconPrefix,
} from '@fortawesome/fontawesome-svg-core';

export const facZendesk = {
  prefix: 'fac' as IconPrefix,
  iconName: 'zendesk' as IconName,
  icon: [
    256,
    200,
    [],
    null,
    'M118.25 51.23v142.78H0L118.25 51.23Zm0-51.23A59.14 59.14 0 0 1 0 0h118.25Zm19.5 194a59.1 59.1 0 0 1 59.13-59.12A59.12 59.12 0 0 1 256 194.01H137.75Zm0-51.26V0H256L137.75 142.74Z',
  ],
} as unknown as IconDefinition;
